import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung | ViraAi";
  }, []);
  return (
    <div style={{ backgroundColor: "#0A0A0A", minHeight: "100vh", color: "#F0EDE8", fontFamily: "'Inter', sans-serif" }}>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#C9A84C] hover:text-[#E0C375] transition-colors mb-10 text-sm font-medium"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <h1
          className="text-3xl sm:text-4xl font-black text-[#F0EDE8] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-[#9A9A9A] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-[#F0EDE8] font-semibold mb-2">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">2. Verantwortlicher</h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br /><br />
              Magic Design Agents UG (haftungsbeschränkt)<br />
              Inhaber: Luca Berg<br />
              Bochum, Deutschland<br />
              E-Mail: info@viraai.de
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">3. Datenerfassung auf dieser Website</h2>
            <h3 className="text-[#F0EDE8] font-semibold mb-2">Cookies</h3>
            <p>
              Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete
              und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend
              für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf
              Ihrem Endgerät gespeichert.
            </p>
            <br />
            <h3 className="text-[#F0EDE8] font-semibold mb-2">Server-Log-Dateien</h3>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so
              genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies
              sind: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL,
              Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage sowie IP-Adresse.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">4. Analyse-Tools und Werbung</h2>
            <h3 className="text-[#F0EDE8] font-semibold mb-2">PostHog</h3>
            <p>
              Diese Website nutzt PostHog, ein Analyse-Tool zur Auswertung von Nutzerverhalten.
              Anbieter ist PostHog Inc., 965 Market St, San Francisco, CA 94103, USA. PostHog
              verwendet Cookies, um eine Analyse der Benutzung der Website durch Sie zu
              ermöglichen. Die dadurch erzeugten Informationen werden auf Servern von PostHog
              gespeichert.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">5. Ihre Rechte</h2>
            <p>
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
              Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem
              das Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
              Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung
              jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten
              Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
              verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen
              Aufsichtsbehörde zu.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">6. Zahlungsabwicklung</h2>
            <p>
              Die Zahlungsabwicklung erfolgt über Payhip (Payhip Ltd., UK). Beim Kauf werden Sie
              auf die Payhip-Plattform weitergeleitet. Die Datenschutzrichtlinien von Payhip
              finden Sie unter{" "}
              <a href="https://payhip.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#C9A84C] hover:underline">
                payhip.com/privacy
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
